export default "__VITE_ASSET__cCvnRlrY__"